import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { UsRegisterHospitalsService } from './us-register-hospitals.services';
import { OPEN_ALL_SECTIONS } from '../store/user';
import * as _ from 'lodash';
import { Subscription } from 'rxjs/Rx';

@Component({
  selector: 'app-us-register-hospitals',
  templateUrl: './us-register-hospitals.component.html',
  styleUrls: ['./us-register-hospitals.component.css']
})
export class UsRegisterHospitalsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];

  // header
  header: string;
  subHeader: string;
  paragraphText = '';

  // Used to manage state of full screen in all app
  currentUserUIScreen;

  // Spinner
  searchProgress = false;

  // Error Fetching Data?
  errorFetching = false;

  // Table Data
  table2data;
  tableHeaders: any;
  tableHeadersDisplay: any;
  tableSubHeadersDisplay: any = [];
  tableHeaderLocationCount = 0;
  tableControlsOpen = true;

  // table2DataAll: any;
  finalTable2Data: any;
  finalTable2DataDisplay: any;
  downloads: any;

  // Mobile
  columnToDisplayMobile = 0;
  finalTable2DataColumn;

  constructor(
    private store: Store<any>,
    private usRegisterHospitalsService: UsRegisterHospitalsService
  ) {
    this.subscriptions.push(
      store.select('currentUser').subscribe(currentUser => {
        this.currentUserUIScreen = currentUser;
        this.setTableControlsOpen(currentUser);
      })
    );
  }

  ngOnInit() {
    this.getTableData();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      if (typeof subscription.unsubscribe === 'function') {
        subscription.unsubscribe();
      }
    });
  }

  /**
   * setTableControlsOpen
   * @param currentUser
   * Set Tables Controls Open
   */
  setTableControlsOpen(currentUser) {
    this.tableControlsOpen = currentUser.tableControlsOpen;
  }

  /**
   * getTableData()
   * @returns {boolean}
   * Call's Table Service for Table2Data and Builds Package for Display
   */
  getTableData() {
    const searchOpts = {
      tableId: 'us-reg',
      sYear: '2022'
    };
    this.searchProgress = true;

    this.subscriptions.push(
      this.usRegisterHospitalsService.getTable2Data(searchOpts).subscribe(
        ({ data }) => {
          this.table2data = data.getTable2Data;
          this.downloads = this.table2data.download;
          this.searchProgress = false;
          const htmlArray = this.table2data.tableTitle.split(':');
          this.header = htmlArray[0];
          this.subHeader = htmlArray[1];
          this.paragraphText = this.table2data.tableDetails
            .replace(/>\s+</g, '><')
            .replace(/(\r\n|\n|\r)/gm, '')
            .trim();
          this.processHeaders(this.table2data.data.headers);
          this.processData(this.table2data.data.section);
          this.errorFetching = false;
        },
        error => {
          console.error('error fetching from graphql', error);
          this.searchProgress = false;
          this.errorFetching = true;
        }
      )
    );
    return true;
  }

  /**
   * processData(data = Table2Data, count = 0)
   * @param data
   * @param {number} count
   * @returns {boolean}
   * ProcessData for frontend Display
   */
  processData(data, count = 0) {
    let returnData = false;
    this.finalTable2Data = data;
    const headers = _.cloneDeep(this.finalTable2Data);
    if (this.tableHeaders.length > 5) {
      _.forEach(headers, function(value) {
        value.row[0].cell = value.row[0].cell.slice(count, count + 5);
        if (value.hasOwnProperty('subsection') && value.subsection !== null) {
          _.forEach(value.subsection, function(valuea) {
            if (valuea.hasOwnProperty('subsection') && valuea.subsection !== null) {
              _.forEach(valuea.subsection, function(valueb) {
                valueb.cell = valueb.row[0].cell.slice(count, count + 5);
              });
            }
            valuea.cell = valuea.row[0].cell.slice(count, count + 5);
          });
          value.subsection.push(value.row[0]);
        }
      });
      this.finalTable2DataDisplay = headers;
      this.filterDataByColumnsIndex(this.finalTable2DataDisplay);
      returnData = true;
    } else {
      this.finalTable2DataDisplay = this.finalTable2Data;
      returnData = true;
    }
    return returnData;
  }

  /**
   * processHeaders(cells, count = 0)
   * @param cells
   * @param {number} count
   * @returns {boolean}
   * Process Headers to display above col data.
   */
  processHeaders(cells, count = 0) {
    let returnData = false;
    this.tableHeaders = cells;
    const headers = _.cloneDeep(this.tableHeaders);
    if (this.tableHeaders.length > 5) {
      this.tableHeadersDisplay = headers.slice(count, count + 5);
      returnData = true;
    } else {
      this.tableHeadersDisplay = this.tableHeaders;
      returnData = true;
    }
    this.processSubHeaders(this.tableHeadersDisplay);
    return returnData;
  }

  /**
   * processSubHeaders(data)
   * @param data
   * Process Sub Headers to display over header over columns
   */
  processSubHeaders(data) {
    this.tableSubHeadersDisplay = [];
    const me = this;
    _.forEach(data, function(item, key) {
      const content: any = {};
      const title = item.heading ? item.heading : '&nbsp';
      if (key > 0) {
        const lastKey = key - 1;
        const lastTitle = me.tableSubHeadersDisplay[lastKey].title
          ? me.tableSubHeadersDisplay[lastKey].title
          : '&nbsp';
        if (lastTitle === title) {
          content['title'] = title;
          content['enabled'] = false;
          content['col'] = 0;
          const startKey = me.tableSubHeadersDisplay[lastKey].key;
          content['key'] = startKey;
          me.tableSubHeadersDisplay[startKey].col = me.tableSubHeadersDisplay[startKey].col + 1;
        } else {
          content['title'] = title;
          content['enabled'] = true;
          content['col'] = 1;
          content['key'] = key;
        }
      } else {
        content['title'] = title;
        content['enabled'] = true;
        content['col'] = 1;
        content['key'] = key;
      }
      me.tableSubHeadersDisplay.push(content);
    });
  }

  /**
   * filterDataByColumnsIndex(data, currentColumn = 0)
   * @param data
   * @param {number} currentColumn
   * Filter Data by Current Columns Index
   */
  filterDataByColumnsIndex(data, currentColumn = 0) {
    const cloneData = _.cloneDeep(data);
    const filteredColumn = cloneData.map(function(obj) {
      obj.row[0].cell = obj.row[0].cell.filter((cell, index) => currentColumn === index);

      if (obj.subsection !== null) {
        obj.subsection.map(function(subsection) {
          subsection.cell = subsection.cell.filter((cell, index) => currentColumn === index);
          if (subsection.subsection !== null && subsection.subsection !== undefined) {
            subsection.subsection = subsection.subsection.map(function(obj) {
              obj.cell = obj.cell.filter((cell, index) => currentColumn === index);
              return obj;
            });
          }
        });
      }
      return obj;
    });
    this.finalTable2DataColumn = filteredColumn;
  }

  /**
   * tableHeaderLeft()
   * @returns {boolean}
   * Move Headers Left
   */
  tableHeaderLeft() {
    let returnData = false;
    if (this.tableHeaderLocationCount > 0) {
      this.tableHeaderLocationCount--;
      this.processHeaders(this.tableHeaders, this.tableHeaderLocationCount);
      this.processData(this.finalTable2Data, this.tableHeaderLocationCount);
      returnData = true;
    }
    return returnData;
  }

  /**
   * tableHeaderRight()
   * @returns {boolean}
   * Move Headers Right
   */
  tableHeaderRight() {
    let returnData = false;
    if (this.tableHeaderLocationCount < this.tableHeaders.length - 5) {
      this.tableHeaderLocationCount++;
      this.processHeaders(this.tableHeaders, this.tableHeaderLocationCount);
      this.processData(this.finalTable2Data, this.tableHeaderLocationCount);
      returnData = true;
    }
    return returnData;
  }

  /**
   * tableHeaderMobileLeft()
   * Move Headers Left on Mobile
   */
  tableHeaderMobileLeft() {
    if (this.columnToDisplayMobile === 0) {
      const leftColumnToShow = this.tableHeaderLeft();
      if (leftColumnToShow) {
        this.columnToDisplayMobile = 4;
      }
    } else {
      this.columnToDisplayMobile--;
      this.filterDataByColumnsIndex(this.finalTable2DataDisplay, this.columnToDisplayMobile);
    }
  }

  /**
   * tableHeaderMobileRight()
   * Move Headers Right on Mobile
   */
  tableHeaderMobileRight() {
    if (this.columnToDisplayMobile === 4) {
      this.columnToDisplayMobile = 0;
      this.tableHeaderRight();
    } else {
      this.columnToDisplayMobile++;
      this.filterDataByColumnsIndex(this.finalTable2DataDisplay, this.columnToDisplayMobile);
    }
  }

  /**
   * expandAll()
   * Expand All Rows
   */
  expandAll() {
    this.store.dispatch({
      type: OPEN_ALL_SECTIONS,
      payload: {
        allSectionsOpen: true
      }
    });
  }

  /**
   * collapseAll()
   * Collapse All Rows
   */
  collapseAll() {
    this.store.dispatch({
      type: OPEN_ALL_SECTIONS,
      payload: {
        allSectionsOpen: false
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/t2-us-register-hospitals/us-register-hospitals.component.ts